import { type CardPaymentMethodFormViewModel } from '@/features/jobs/drafting/checkout/CardPaymentMethodFormViewModel'
import { observer } from 'mobx-react-lite'
import { Form, FormRow } from '@/components/Form'
import { FormGroupContainer } from '@/components/FormContainer'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { CountryInput } from '@/components/inputs/CountryInput'
import { Button } from '@/components/Button'
import { CardInput } from '@/features/jobs/drafting/checkout/components/Checkout/Payment/CardInput'

export interface CardPaymentMethodFormContainerProps {
  vm: CardPaymentMethodFormViewModel
}

export const CardPaymentMethodFormContainer = observer(
  function CardPaymentMethodFormContainer({
    vm,
  }: CardPaymentMethodFormContainerProps) {
    const testId = 'add-card-form'
    return (
      <Form onSubmit={vm.pay} isSubmitDisabled={vm.formDisabled}>
        <FormRow>
          <CardInputContainer
            isDisabled={vm.formDisabled}
            vm={vm}
            testId={`${testId}-card-input`}
          />
        </FormRow>
        <FormRow>
          <TextInputContainer
            model={vm}
            field="fullName"
            label="Cardholder name"
            name="name"
            autoFocus
            placeholder="Please enter the full name as it is displayed on your card."
            isDisabled={vm.formDisabled}
            error={vm.validation.getError('fullName')}
            data-test={`${testId}-full-name-input`}
          />
        </FormRow>
        <FormRow>
          <FormGroupContainer
            htmlFor="country"
            label="Country"
            error={vm.validation.getError('country')}
          >
            <CountryInput
              isDisabled={vm.formDisabled}
              value={vm.country}
              onChange={vm.setCountry}
              testId={`${testId}-country-input`}
            />
          </FormGroupContainer>
        </FormRow>
        <FormRow>
          <TextInputContainer
            model={vm}
            field="zipCode"
            name="zip"
            label="Zip"
            placeholder="Zip Code"
            isDisabled={vm.formDisabled}
            error={vm.validation.getError('zipCode')}
            data-test={`${testId}-zip-input`}
          />
        </FormRow>
        <FormRow></FormRow>
        <FormRow>
          <Button
            label="Pay"
            type="submit"
            variant="primary"
            size="wide"
            isPending={vm.pay.pending}
            isDisabled={vm.pay.pending}
          />
        </FormRow>
      </Form>
    )
  },
)

interface CardInputContainerProps {
  vm: CardPaymentMethodFormViewModel
  isDisabled: boolean
  testId?: string
}

const CardInputContainer = observer(function CardInputContainer({
  vm,
  isDisabled,
  testId,
}: CardInputContainerProps) {
  return (
    <CardInput
      error={vm.validation.getError('card')}
      isDisabled={isDisabled}
      onChange={vm.handleCardChange}
      onReady={vm.setCard}
      testId={testId}
    />
  )
})
